module.exports = __webpack_public_path__ + "img/DSTV.c52056be.svg";